import axios from "axios";
import { setcurrency } from "src/store/slices/currency-slice";
import { setglobalData } from "src/store/slices/globalData-slice";
import { store } from "src/store/store";
import { getImageUrl } from "src/utils/imageUrl";
import { currencyMap } from "src/utils/Mapper";

export const fetchGlobalData = async (shopId = null) => {
  try {
const currentUrl =  window.location.origin;

     const tempApi = axios.create({
      baseURL: process.env.REACT_APP_API_HTTPS_URL,
      headers: {
        "Content-Type": "application/json",
        "Url": currentUrl,
      },
    });

    const response = await tempApi.get(`/businessinfo`);
    if (response.data) {
      let policies = null;
      try {
        const policyResponse = await tempApi.get(`/policy`);
        if (Array.isArray(policyResponse.data)) {
          policies = policyResponse.data;
        }
      } catch (policyError) {
        // Policies (shipping/terms/privacy/refund pages) are optional —
        // don't let a missing/failed /policy call break the rest of the
        // storefront's global data.
        console.error("Error fetching policies:", policyError);
      }
      // Only override what /businessinfo already gave us when /policy actually
      // answered — otherwise a failed call would blank the footer policy links.
      store.dispatch(
        setglobalData(policies ? { ...response.data, policies } : response.data)
      );
      const currencyCode = response.data.currency?.toLowerCase();
      const currencySymbol = currencyMap[currencyCode] || response.data.currency;
      store.dispatch(setcurrency(currencySymbol));

      document.title = response.data.businessName;

      // Update favicon
      const favicon = document.querySelector("link[rel='icon']");
      if (favicon) {
        // Check if logoUrl is a full URL or just a path
        const imageUrl = getImageUrl(response.data.logoUrl);

        favicon.href = imageUrl;

        const appleIcon = document.querySelector("link[rel='apple-touch-icon']");
        if (appleIcon) {
          appleIcon.href = imageUrl;
        }
      }

      // Return the shopId from the response
      return response.data.shopId;
    }
  } catch (error) {
    console.error("Error fetching global data:", error);
    throw error;
  }

};


